/**
 * 资料库的一级分类（L-01）。
 *
 * 顺序与标签是导航与资料库视图的唯一来源：左栏「内容导航」的二级项、
 * `LibraryDialog` 的 tab 条、测试都从这里取，避免两处各写一套。
 */
export type LibraryTab = "world" | "characters" | "props" | "terms" | "assets";

export const LIBRARY_TAB_ORDER: readonly LibraryTab[] = [
  "world",
  "characters",
  "props",
  "terms",
  "assets",
];

export const LIBRARY_TAB_LABELS: Record<LibraryTab, string> = {
  world: "世界",
  characters: "角色",
  props: "道具",
  terms: "术语",
  assets: "资产版本",
};
